import worksiteApi from '../../api/worksite'

// initial state
const state = {
}

const getters = {
}

const actions = {
  getWorksite ({ dispatch, commit }, id) {
    return new Promise((resolve, reject) => {
      worksiteApi.getWorksite(id, worksite => {
        resolve(worksite)
      },
      error => {
        reject(error)
      })
    })
  },

}

const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
